import React from "react";
import styled from "styled-components";
import { MinusOutlined } from "@ant-design/icons";

import { lightGreyText } from "../../styles";
import voteForIcon from "../../assets/svg/implicit_temperature_success.svg";
import voteAgainstIcon from "../../assets/svg/implicit_temperature_fail.svg";

export enum VoteDecision {
  FOR = "FOR",
  AGAINST = "AGAINST",
  OTHER = "OTHER",
}

const Icon = styled.img`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`;

const Neutral = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  border-radius: 50%;
  font-size: 8px;
  color: white;
  background: ${lightGreyText};
`;

export const toVoteDecision = (value: string): VoteDecision => {
  const v = value.trim().toLowerCase();
  if (v === "for") return VoteDecision.FOR;
  if (v === "against") return VoteDecision.AGAINST;
  return VoteDecision.OTHER;
};

export const VoteDecisionMark = ({
  decision,
}: {
  decision: VoteDecision;
}): JSX.Element => {
  if (decision === VoteDecision.FOR) return <Icon src={voteForIcon} alt="" />;
  if (decision === VoteDecision.AGAINST)
    return <Icon src={voteAgainstIcon} alt="" />;
  return (
    <Neutral aria-hidden="true">
      <MinusOutlined />
    </Neutral>
  );
};
